import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaUser, FaClock } from 'react-icons/fa';
import { api } from '../../App';
import { AdminLayout } from './AdminDashboard';
import './Admin.css';

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const data = await api.get('/api/admin/contacts');
      setContacts(data.contacts || []);
    } catch (error) {
      console.error('Failed to fetch contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('sl-SI', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <AdminLayout title="Prejeta sporočila">
      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Nalaganje sporočil...</p>
        </div>
      ) : contacts.length === 0 ? (
        <motion.div
          className="empty-state"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{ 
            background: 'var(--bg-card)', 
            border: '1px solid var(--border-color)',
            borderRadius: '12px',
            padding: '60px'
          }}
        >
          <FaEnvelope style={{ fontSize: '48px', color: 'var(--gold-primary)', marginBottom: '16px' }} />
          <h3>Še ni prejetih sporočil</h3>
          <p>Sporočila s kontaktnega obrazca bodo prikazana tukaj.</p>
        </motion.div>
      ) : (
        <div className="contacts-list">
          {contacts.map((contact, index) => (
            <motion.div
              key={contact.id}
              className={`contact-card ${!contact.is_read ? 'unread' : ''}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.3 }}
            >
              <div className="contact-header">
                <div className="contact-info">
                  <h3>
                    <FaUser style={{ marginRight: '8px', color: 'var(--gold-primary)' }} />
                    {contact.name}
                  </h3>
                  <p>
                    <FaEnvelope style={{ marginRight: '6px' }} />
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </p>
                </div>
                <div className="contact-date">
                  <FaClock style={{ marginRight: '6px' }} />
                  {formatDate(contact.created_at)}
                </div>
              </div>
              
              {contact.subject && (
                <div className="contact-subject">
                  {contact.subject}
                </div>
              )}
              
              <div className="contact-message">
                {contact.message}
              </div>
              
              <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid var(--border-color)' }}>
                <a 
                  href={`mailto:${contact.email}?subject=Re: ${contact.subject || 'Vaše povpraševanje'}`}
                  className="btn btn-outline"
                  style={{ fontSize: '12px', padding: '8px 16px' }}
                >
                  <FaEnvelope /> Odgovori
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminContacts;

